export default __webpack_public_path__ + "static/media/ap-card-error.760ae67a.svg";